$(document).ready(function() {
    $('.testimonial-carousel').slick({
        dots: true
    })
    $(document).on('click', '.full-images-slide .icons li', function() {
        var id = $(this).attr('id')
        var sel = '.'+id
        $('.full-images-slide .icons li').removeClass('active')
        $(this).addClass('active')
        $('.full-images-slide .images li').removeClass('show')
        $('.full-images-slide .images').find(sel).addClass('show')
    })
    /*
    $(document).on('click', '.delivery-main-info-cont', function() {
        $(this).toggleClass('opened')
    })
    */
    $(document).on('click', '.faq-subtitle', function() {
        $(this).toggleClass('opened')
    })
    $(document).on('click', '.faq-inner-list .question', function() {
        $(this).toggleClass('faq-selected')
    })
    /*
    $(document).on('click', '.close-cookies', function() {
        $(".cookie-cont").addClass('accepted')
        $( ".cookie-cont" ).animate({
            opacity: 0.25,
            bottom: "-=50",
        }, 1000, function() {
            // Animation complete.
        });
    })
    */

    $(document).on('click', '.track-map .track-info', function() {
        $(this).toggleClass('opened')
    })

    /*
    $(document).on('click', '.footer .lang', function() {
        $(this).toggleClass('opened')
    })
    */

    /*
    $(document).mouseup(function (e){
        var container = $(".footer .lang .lang-cont");
        if (!container.is(e.target) // if the target of the click isn't the container...
            && container.has(e.target).length === 0) // ... nor a descendant of the container
        {
            $('.footer .lang').removeClass('opened')
        }
    });
    */

    //Show elements on window load.
    //$('.cookie-cont').show()
})
